import React, { useEffect, useState } from "react";
import {
  copyIcon,
  downIcon,
  eyeIcon,
  plusIcon,
  refresh,
  timeIcon,
} from "../../../Base/SVG";
import { motion } from "framer-motion";

export default function Rewards() {
  const [isLoading, setIsLoading] = useState(true);
  const lazyDummy = () => {
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  };
  useEffect(() => {
    lazyDummy();
  }, []);
  return (
    <div className="rewards">
      <div className="auto__container">
        {isLoading ? (
          <>
            <div className="rewards__head">
              <div className="rewards__info">
                <h3 className="placeholder"></h3>
                <h4 className="placeholder"></h4>
                <div className="rewards__info-percent placeholder"></div>
                <div className="rewards__info-btns">
                  <div className="button placeholder"></div>
                  <div className="button placeholder"></div>
                </div>
              </div>
            </div>
            <div className="rewards__inner">
              <div className="rewards__inner-col placeholder"></div>
              <div className="rewards__inner-col placeholder"></div>
            </div>
          </>
        ) : (
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.2 }}
            exit={{ opacity: 0, y: 10 }}
          >
            <div className="rewards__head">
              <div className="rewards__info">
                <h3>Rewards</h3>
                <h4>Commit PLINK, earn up to</h4>
                <div className="rewards__info-percent">22.20% APY</div>
                <div className="rewards__info-btns">
                  <a href="#" className="button uniq">
                    <span> Buy $PLINK</span> {copyIcon}
                  </a>
                  <a href="#" className="rewards__info-add">
                    Add to Wallet {plusIcon}
                  </a>
                </div>
              </div>
              <div className="rewards__image">
                <img
                  src={process.env.PUBLIC_URL + "/images/tokenImage.png"}
                  alt="tokenImage"
                />
              </div>
            </div>
            <div className="rewards__inner">
              <div className="rewards__inner-col">
                <div className="rewardsItem box">
                  <div className="rewardsItem__row">
                    <h5>Standard Method</h5>
                    <div className="rewardsItem__percent">
                      20.38% <button type="button">{refresh}</button>
                    </div>
                  </div>
                  <div className="rewardsItem__row">
                    <p>Earn PLINK and platform fees on all networks!</p>
                    <p>APY</p>
                  </div>
                  <a href="#" className="button uniq">
                    <span>Connect</span>
                  </a>
                </div>
                <div className="rewardsItem box">
                  <div className="rewardsItem__row">
                    <h5>Global Stats</h5>
                  </div>
                  <div className="rewardsItem__infos">
                    <div className="rewardsItem__info">
                      <p>Total Committed</p>
                      <div className="rewardsItem__info-views">
                        {eyeIcon}
                        597,877,352
                      </div>
                    </div>
                    <div className="rewardsItem__info">
                      <p>Next Distribution Start</p>
                      <div className="rewardsItem__info-views">
                        {timeIcon}
                        22h 17m
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="rewards__inner-col">
                <div className="rewardsItem box">
                  <div className="rewardsItem__icon">{downIcon}</div>
                  <h4 className="big">Protocol Rewards</h4>
                  <p>
                    100% of Paylink's platform fees are distributed between
                    $PLINK stakers.
                  </p>
                  <div className="rewardsItem__more">
                    <h5>Standard Method:</h5>
                    <p>Earn PLINK and platform fees on all networks</p>
                  </div>
                  <a href="#" className="button uniq">
                    <span>Learn More</span>
                  </a>
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </div>
    </div>
  );
}
